import React from 'react';
import { motion } from 'framer-motion';
import { HeartFilled } from '@ant-design/icons';

const Footer = () => {
  return (
    <motion.footer 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, delay: 0.2 }}
      className="bg-white/75 backdrop-blur-md border-t border-primary/10 mt-8 pb-8 sm:pb-12 shadow-[0_-8px_32px_rgba(102,52,241,0.06)]"
    >
      <div className="px-3 sm:px-4 md:px-6 py-4 sm:py-5 max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-3">
          <p className="text-xs sm:text-xs text-neutral-500 text-center sm:text-left">
            © 2025 <span className="font-semibold text-primary">HindukushSoft Technologies</span>. All rights reserved.
          </p>
          <p className="text-xs sm:text-xs text-neutral-500 flex items-center justify-center">
            Built with <HeartFilled className="heartbeat-emoji" style={{ fontSize: '1em', color: '#ff4d4f' }} /> by{' '}
            <a 
              href="https://www.hindukushsoft.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="font-semibold text-primary hover:underline ml-1"
            >
              HindukushSoft Technologies
            </a>
          </p>
        </div>
      </div>
      
      {/* Gold Accent Line */}
      <div className="h-1.5 bg-primary" />
    </motion.footer>
  );
};

export default Footer;
